import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmbedLoginService, JwtService, UtilsService } from '@core/services';
import { AuthService } from '../auth.service';
import { APPS } from '@core/assets/constants';

/**
 * Allows choosing, from the received token, the Kepler player (match) to log in
 * as, when a single token grants access to several players.
 */
@Component({
  selector: 'app-kepler-match-selector',
  templateUrl: './kepler-match-selector.component.html',
  styleUrls: ['./kepler-match-selector.component.scss']
})
export class KeplerMatchSelectorComponent implements OnInit {
  public matches: Array<any> = [];
  public error: any = null;
  private token: string = null;
  public keplerSid: string = APPS.kepler;

  constructor(
    public utilsService: UtilsService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private embedLoginService: EmbedLoginService,
    private jwtService: JwtService
  ) {}

  /**
   * Extracts the available matches to select from the route's token.
   */
  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams.token;
    const data = this.jwtService.getTokenData(this.token);
    this.matches = data.matches;
  }

  /**
   * Authenticates the user with the selected match.
   * @param playerId Identifier of the chosen player/match
   */
  handleSelectMatch(playerId: string): void {
    this.authService
      .createServiceLogin({
        token: this.token,
        sid: APPS.kepler,
        playerId
      })
      .subscribe({
        next: (response) => {
          this.embedLoginService.onLoginSuccess(response);
        },
        error: (error) => {
          console.error(error);
          this.error = error;
        }
      });
  }
}
